import Vue from 'vue'
import App from './App.vue'
import store from './store/store'
import vuetify from './plugins/vuetify'
import './assets/common.scss'

Vue.config.productionTip = false

// Jeżeli ma być preview, to zapisanie w sessionStorage i przeładowanie
let url = new URL(window.location.href)
if (url.searchParams.get('preview') != null) {
  window.sessionStorage.setItem(
    'blank.preview',
    url.searchParams.get('preview') === 'enable'
  )
  // console.log([
  //   'preview set to: ',
  //   JSON.parse(window.sessionStorage.getItem('blank.preview'))
  // ])

  // Redirect
  url.searchParams.delete('preview')
  window.location = url.toString()
} else {
  new Vue({
    store,
    vuetify,
    render: (h) => h(App)
  }).$mount('#app')

  // VUE 3.x - mozliwe dopiero gdy vuetify da sie zaladowac.
  // import { createApp } from 'vue';
  // import App from "./App.vue";
  // import { createStore } from './store/store3';
  // import vuetify from "./plugins/vuetify";

  // const app = createApp(App);
  // app.use(createStore());
  // app.use(vuetify);
  // app.mount("#app");
}
